<template>
  <tr class="shopping-cart-item">
    <td class="shopping-cart-item__value shopping-cart-item__value--title-wrapper">
      <h4 class="shopping-cart-item__title">{{ itemInfo.priceclass.priceClassName.priceClassName }}</h4>
      <!-- If level or section are present -->
      <p class="shopping-cart-item__section" v-if="getProductSection || getProductLevel">
        <span v-if="getProductLevel">{{ getProductLevel }}</span>
        <!-- if both section & level are present, show the separator -->
        <span v-if="getProductSection && getProductLevel"> - </span>
        <span v-if="getProductSection">{{ getProductSection }}</span>
      </p>
      <div class="shopping-cart-item__value shopping-cart-item__value--seat-details" v-html="seatDetails"></div>
    </td>
    <td class="shopping-cart-item__value shopping-cart-item__value--quantity">{{ itemInfo.quantity }}</td>
    <td class="shopping-cart-item__value shopping-cart-item__value--unit-price">{{ formattedPrice(itemInfo.unitPrice.amount) }}</td>
    <td class="shopping-cart-item__value shopping-cart-item__value--booking-fee">{{ formattedPrice(itemInfo.bookingFee.amount) }}</td>
    <td class="shopping-cart-item__value shopping-cart-item__value--total-price">
      <span class="price">{{ formattedPrice(itemInfo.subTotal.amount) }}</span>
      <font-awesome-icon class="icon--delete-shopping-item" :icon="['far', 'minus-circle']" @click="confirmDeletion" />
    </td>
  </tr>
</template>

<script>
import _ from "lodash"
import Helpers from "@/util/helpers"

export default {
  name: "shopping-cart-item",
  mixins: [Helpers],
  props: {
    itemInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    confirmDeletion() {
      this.$emit("confirmDeletion", this.itemInfo);
    },
  },
  computed: {
    seatDetails() {
      let seatInfo = null;
      let row = this.itemInfo.product.row ? this.itemInfo.product.row : "";
      let seats = this.itemInfo.product.seatNo
        ? this.itemInfo.product.seatNo
        : [];

      let seatNumbers = "";

      // Print out the seat details if available (seated events only).
      if (seats.length > 0) {
        seats.forEach(() => {
          seatNumbers = seats.join(
            "</span><span class='seat-details__highlight'>"
          );
        });
        // Add seat details to the line item.
        seatInfo = `
          <div class="seat-details__item"><span class="seat-details__label">` + this.$t('seating_selection_info.row') + `</span>
          <span class="seat-details__highlight">${row}</span></div><span class="seat-details--mobile-breaker"></span>
          <div class="seat-details__item"><span class="seat-details__label">` + this.$t('seating_selection_info.seat') + `</span>
          <span class="seat-details__highlight">${seatNumbers}</span></div>`;
      } else {
        return ""
      }

      return seatInfo;
    },
    getProductSection() {
      return _.get(this.itemInfo, "product.section.section", false);
    },
    getProductLevel() {
      return _.get(this.itemInfo, "product.level.level", false);
    },
  },
};
</script>
